import React from 'react'

const InfoLigne = ({ value, pieces, type, marque, index }) => {
  const trimmedValue = value.trim()
  const trimmedMarques = marque?.trim()?.split(',')


  let count = 0
  let label = trimmedValue

  if (type === 'immat') {
    count = pieces.filter(
      (item) => item?.clientDemandeImmat?.immatriculation?.trim() === trimmedValue
    ).length
    label = trimmedValue
  }

  if (type === 'modele' ) {
    const filtered = pieces.filter((item) => item?.modele?.trim() === trimmedValue)
    count = filtered.length
    marque = filtered.length > 0 ? filtered[0].marque : null
    label = `${marque ?? ''} / ${trimmedValue}${type === 'modeleVht' ? ' [VHT] ' : ''}`
  }

  if (type === 'modeleVht') {
    const filtered = pieces.filter((item) => item?.modele?.trim() === trimmedValue && item?.marque?.trim() === trimmedMarques?.[index])
    count = filtered.length
    label = `${trimmedMarques?.[index] ?? ''} / ${trimmedValue}${
      type === 'modeleVht' ? ' [VHT]' : ''
    }`
  }

  return (
    <p className='text-gray-800 text-hover-primary d-block fs-6 mb-0'>
      {`${label} (${count})`}
    </p>
  )
}

export default InfoLigne
